import React, { Fragment, useEffect, useState } from "react";
import { Row, Col, Table, Card } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { fetchGRNProductsByProductId } from "slices/Warehouse/ItemInward/GRN/thunk";
import PageContainer from "Common/Components/PageContainer/PageContainer";
import PageBreadcrumb from "Common/Components/PageBreadcrumb/PageBreadcrumb";
import CancelButton from "Common/Components/Buttons/CancelButton";
import { MecordColors } from "Constants/Color";
import FormattedDate from "Common/Components/NameWithDate.tsx/FormattedDate";
import { toast } from "react-toastify";
import LoadingSpinner from "Common/Components/LoaderErrorWrapper/LoadingSpinner";
import "../../../../Constants/common-table.css";
import Tooltip from "@mui/material/Tooltip";

const GRNItemDetails = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { inventory_id, product_id } = useParams<any>();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch<any>();
  const [data, setData] = useState<any>([]);

  useEffect(() => {
    if (inventory_id && product_id) {
      setLoading(true);
      dispatch(fetchGRNProductsByProductId({ inventory_id, product_id }))
        .unwrap()
        .then((data: any) => {
          setData(data?.data);
          console.log("Product CODE", data.data);
        })
        .catch((err: any) => {
          console.error("Error:", err);
          toast.error(err?.message || "Failed to fetch GRN details");
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [dispatch, inventory_id]);

  const displayValue = (val: any) => val || "-";

  console.log("Inventory Items data : ", data);

  return (
    <Fragment>
      <PageContainer>
        <PageBreadcrumb
          title="View GRN Product Details"
          titleLink="/warehouse-item-inward"
          breadcrumbs={[
            {
              label: "View GRN Details",
              to: `/grn-view-details/${inventory_id}`,
            },
            { label: "View GRN Product Details", to: "" },
          ]}
          backNavigationPath={-1}
        />
        <hr />

        {loading ? (
          <LoadingSpinner />
        ) : (
          <>
            <Row className="mb-3">
              <Col md={6}>
                <p className="mb-3">
                  <strong>GRN No. :</strong> {displayValue(data?.grn_no)}
                </p>
              </Col>
              <Col md={6}>
                <p className="mb-3">
                  <strong>GRN Date :</strong>{" "}
                  <FormattedDate date={data?.created_at} />
                </p>
              </Col>
              {state?.listType === "PO" && (
                <>
                  <Col md={6}>
                    <p className="mb-3">
                      <strong>PO No. :</strong> {displayValue(data?.po_no)}
                    </p>
                  </Col>
                  <Col md={6}>
                    <p className="mb-3">
                      <strong>PO Date :</strong>{" "}
                      <FormattedDate date={data?.po_date} />
                    </p>
                  </Col>
                </>
              )}
              <Col md={6}>
                <p className="mb-3">
                  <strong>Delivery Challan No. :</strong>{" "}
                  {displayValue(data?.delivery_challan_no)}
                </p>
              </Col>
              <Col md={6}>
                <p className="mb-3">
                  <strong>LR No. :</strong> {displayValue(data?.lr_no)}
                </p>
              </Col>
              <Col md={6}>
                <p className="mb-3">
                  <strong>Received By :</strong>{" "}
                  {displayValue(data?.received_by)}
                </p>
              </Col>
            </Row>

            <hr />

            <div className="my-4">
              <h6 className="fw-semibold mb-2" style={{ fontSize: "0.9rem" }}>
                Product Details
              </h6>
              <div className="mb-4" style={{ overflowX: "auto" }}>
                <Table responsive className="align-middle text-center">
                  <thead
                    style={{ backgroundColor: MecordColors.LightGrayColor }}
                  >
                    <tr>
                      <th style={{ minWidth: "70px" }}>Sr No.</th>
                      <th style={{ minWidth: "120px" }}>Product Name</th>
                      <th style={{ minWidth: "120px" }}>Product Code</th>
                      <th style={{ minWidth: "100px" }}>Unit</th>
                      <th style={{ minWidth: "140px" }}>Warranty Date</th>
                      <th style={{ minWidth: "120px" }}>Serial No.</th>
                      <th style={{ minWidth: "100px" }}>QC</th>
                      <th style={{ minWidth: "150px" }}>Remarks</th>
                    </tr>
                  </thead>
                  <tbody style={{ backgroundColor: "#ffffff" }}>
                    {data?.inventory_products &&
                    data.inventory_products.length > 0 ? (
                      data.inventory_products.map(
                        (product: any, idx: number) => (
                          <tr key={product.id}>
                            <td>{idx + 1}</td>
                            <td>
                              {displayValue(product?.product?.product_name)}
                            </td>
                            <td>{displayValue(product?.product_code)}</td>
                            <td>
                              {displayValue(product?.product?.unit?.unit_name)}
                            </td>
                            <td>
                              <FormattedDate date={product.warranty_date} />
                            </td>
                            <td>{displayValue(product?.serial_no)}</td>
                            <td>{displayValue(product?.qc)}</td>
                            <td>
                              <Tooltip
                                title={displayValue(product?.remark) || ""}
                                arrow
                              >
                                <span
                                  style={{
                                    maxWidth: "200px",
                                    display: "inline-block",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    verticalAlign: "middle",
                                    cursor: "pointer",
                                  }}
                                >
                                  {displayValue(product?.remark)}
                                </span>
                              </Tooltip>
                            </td>
                          </tr>
                        ),
                      )
                    ) : (
                      <tr>
                        <td colSpan={8} className="text-center">
                          No Data
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </div>

            <div className="d-flex flex-column flex-md-row justify-content-center gap-3 mt-3">
              <CancelButton
                onClick={() => {
                  // Set the tab to GRN (tab 2) in sessionStorage before navigating
                  // sessionStorage.setItem("WarehouseItemInwardTab", "2");
                  navigate(-1);
                }}
                disabled={loading}
                showConfirmation={false}
              />
            </div>
          </>
        )}
      </PageContainer>
    </Fragment>
  );
};

export default GRNItemDetails;
